export default __webpack_public_path__ + "static/media/phq_score.832dcd30.jpeg";